import type { InsightBlock } from '../types/content';

interface Props {
  blocks: InsightBlock[];
}

function Block({ block }: { block: InsightBlock }) {
  if (block.type === 'heading') {
    return <h2>{block.text}</h2>;
  }
  if (block.type === 'list') {
    return (
      <ul>
        {block.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }
  return <p>{block.text}</p>;
}

export default function ArticleBody({ blocks }: Props) {
  return (
    <div className="article-body">
      {blocks.map((block, index) => (
        <Block key={`${block.type}-${index}`} block={block} />
      ))}
    </div>
  );
}
